<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div
                class="d-flex align-items-center"
                style="
                    border-bottom: 1px solid #5c4a4a17;
                    margin: auto !important;
                "
            >
                <div class="row">
                    <div
                        class="col-sm-6 d-flex flex-column align-items-baseline"
                    >
                        <h1 class="m-0 text-dark">Global Stats</h1>
                        <ol class="breadcrumb float-sm-left">
                            <router-link
                                tag="li"
                                class="breadcrumb-item"
                                :to="{ name: 'Home' }"
                                >Home</router-link
                            >
                            <router-link
                                tag="li"
                                class="breadcrumb-item"
                                :to="{ name: 'Dashboard' }"
                                >Dashboard</router-link
                            >
                            <li class="breadcrumb-item active">
                                Global Stats:
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <section class="content mt-3">
            <div
                class="container"
                style="margin: auto !important; overflow: hidden"
            >
                <div class="row d-flex flex-row justify-content-between mb-6">
                    <div class="col-md-3">
                        <span class="index-title">
                            <svg
                                width="18"
                                height="17"
                                viewBox="0 0 18 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="index-title--svg"
                            >
                                <path
                                    d="M5.31667 1.90004L4.125 0.708374C2.125 2.23337 0.808332 4.58337 0.691666 7.25004H2.35833C2.48333 5.04171 3.61667 3.10837 5.31667 1.90004ZM15.6417 7.25004H17.3083C17.1833 4.58337 15.8667 2.23337 13.875 0.708374L12.6917 1.90004C14.375 3.10837 15.5167 5.04171 15.6417 7.25004ZM14 7.66671C14 5.10837 12.6333 2.96671 10.25 2.40004V1.83337C10.25 1.14171 9.69167 0.583374 9 0.583374C8.30833 0.583374 7.75 1.14171 7.75 1.83337V2.40004C5.35833 2.96671 4 5.10004 4 7.66671V11.8334L2.33333 13.5V14.3334H15.6667V13.5L14 11.8334V7.66671ZM9 16.8334C9.11667 16.8334 9.225 16.825 9.33333 16.8C9.875 16.6834 10.3167 16.3167 10.5333 15.8167C10.6167 15.6167 10.6583 15.4 10.6583 15.1667H7.325C7.33333 16.0834 8.075 16.8334 9 16.8334Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Recurring Drips
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row">
                            <div
                                class="d-flex flex-column mt-4"
                                style="width: 50px !important"
                            >
                                <p class="text-left m-1 p-0 font-size-11">
                                    Sent
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Clicks
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Deliveries
                                </p>
                            </div>
                            <v-divider
                                vertical
                                class="m-1"
                                style="height: 80px"
                            ></v-divider>
                            <div class="d-flex justify-content-around">
                                <!-- Recurring Totals -->
                                <div class="m-0">
                                    <p
                                        class="m-1 mt-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    recurring.sends.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    recurring.clicks.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <div
                                        class="mt-1 m-0 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    recurring.deliveries.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0 ml-1">
                                    <p
                                        class="mt-0 mb-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <!-- Recurring This Week Sends -->
                                    <div
                                        class="mt-1 m-0 mb-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.sends.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring This Week Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.clicks.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring This Week Deliveries -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.deliveries
                                                        .thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <router-link
              tag="span"
              :to="{ name: 'More Info' }"
              class="more-info-block cursor-pointer"
            >
              More info
              <svg
                width="7"
                height="11"
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                  fill="#272727"
                />
              </svg>
            </router-link> -->
                    </div>
                    <div class="col-md-3">
                        <span class="index-title">
                            <svg
                                width="18"
                                height="17"
                                viewBox="0 0 18 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="index-title--svg"
                            >
                                <path
                                    d="M5.31667 1.90004L4.125 0.708374C2.125 2.23337 0.808332 4.58337 0.691666 7.25004H2.35833C2.48333 5.04171 3.61667 3.10837 5.31667 1.90004ZM15.6417 7.25004H17.3083C17.1833 4.58337 15.8667 2.23337 13.875 0.708374L12.6917 1.90004C14.375 3.10837 15.5167 5.04171 15.6417 7.25004ZM14 7.66671C14 5.10837 12.6333 2.96671 10.25 2.40004V1.83337C10.25 1.14171 9.69167 0.583374 9 0.583374C8.30833 0.583374 7.75 1.14171 7.75 1.83337V2.40004C5.35833 2.96671 4 5.10004 4 7.66671V11.8334L2.33333 13.5V14.3334H15.6667V13.5L14 11.8334V7.66671ZM9 16.8334C9.11667 16.8334 9.225 16.825 9.33333 16.8C9.875 16.6834 10.3167 16.3167 10.5333 15.8167C10.6167 15.6167 10.6583 15.4 10.6583 15.1667H7.325C7.33333 16.0834 8.075 16.8334 9 16.8334Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Welcome Drips
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row">
                            <div
                                class="d-flex flex-column mt-4"
                                style="width: 50px !important"
                            >
                                <p class="text-left m-1 p-0 font-size-11">
                                    Sent
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Clicks
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Deliveries
                                </p>
                            </div>
                            <v-divider
                                vertical
                                class="m-1"
                                style="height: 80px"
                            ></v-divider>
                            <div class="d-flex justify-content-around">
                                <!-- Welcome Totals -->
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    welcome.sends.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    welcome.clicks.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalMessages
                                            "
                                        >
                                            {{
                                                formatNumber(
                                                    welcome.deliveries.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <!-- Welcome This Week Sends -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.sends.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome This Week Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.clicks.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome This Week Deliveries -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.deliveries.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <router-link
              tag="span"
              :to="{ name: 'More Info' }"
              class="more-info-block cursor-pointer"
            >
              More info
              <svg
                width="7"
                height="11"
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                  fill="#272727"
                />
              </svg>
            </router-link> -->
                    </div>
                    <div class="col-md-3">
                        <span class="index-title">
                            <svg
                                width="20"
                                height="11"
                                viewBox="0 0 20 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="index-title--svg"
                            >
                                <path
                                    d="M10 6.125C11.3583 6.125 12.5583 6.45 13.5333 6.875C14.4333 7.275 15 8.175 15 9.15V10.5H5V9.15833C5 8.175 5.56667 7.275 6.46667 6.88333C7.44167 6.45 8.64167 6.125 10 6.125ZM3.33333 6.33333C4.25 6.33333 5 5.58333 5 4.66667C5 3.75 4.25 3 3.33333 3C2.41667 3 1.66667 3.75 1.66667 4.66667C1.66667 5.58333 2.41667 6.33333 3.33333 6.33333ZM4.275 7.25C3.96667 7.2 3.65833 7.16667 3.33333 7.16667C2.50833 7.16667 1.725 7.34167 1.01667 7.65C0.4 7.91667 0 8.51667 0 9.19167V10.5H3.75V9.15833C3.75 8.46667 3.94167 7.81667 4.275 7.25ZM16.6667 6.33333C17.5833 6.33333 18.3333 5.58333 18.3333 4.66667C18.3333 3.75 17.5833 3 16.6667 3C15.75 3 15 3.75 15 4.66667C15 5.58333 15.75 6.33333 16.6667 6.33333ZM20 9.19167C20 8.51667 19.6 7.91667 18.9833 7.65C18.275 7.34167 17.4917 7.16667 16.6667 7.16667C16.3417 7.16667 16.0333 7.2 15.725 7.25C16.0583 7.81667 16.25 8.46667 16.25 9.15833V10.5H20V9.19167ZM10 0.5C11.3833 0.5 12.5 1.61667 12.5 3C12.5 4.38333 11.3833 5.5 10 5.5C8.61667 5.5 7.5 4.38333 7.5 3C7.5 1.61667 8.61667 0.5 10 0.5Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Subscribers
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row justify-content-center">
                            <div class="d-flex">
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p
                                            class="m-0 p-0"
                                            v-if="
                                                !indexLoader ||
                                                !isLoadingTotalSubs
                                            "
                                        >
                                            {{ formatNumber(subs.subs.totals) }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(subs.subs.thisWeek)
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This month
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    subs.subs.thisMonth
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <router-link
              tag="span"
              :to="{ name: 'More Info' }"
              class="more-info-block cursor-pointer"
            >
              More info
              <svg
                width="7"
                height="11"
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                  fill="#272727"
                />
              </svg>
            </router-link> -->
                    </div>
                    <div class="col-md-2">
                        <span class="index-title">
                            <svg
                                width="20"
                                height="11"
                                viewBox="0 0 20 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="index-title--svg"
                            >
                                <path
                                    d="M10 6.125C11.3583 6.125 12.5583 6.45 13.5333 6.875C14.4333 7.275 15 8.175 15 9.15V10.5H5V9.15833C5 8.175 5.56667 7.275 6.46667 6.88333C7.44167 6.45 8.64167 6.125 10 6.125ZM3.33333 6.33333C4.25 6.33333 5 5.58333 5 4.66667C5 3.75 4.25 3 3.33333 3C2.41667 3 1.66667 3.75 1.66667 4.66667C1.66667 5.58333 2.41667 6.33333 3.33333 6.33333ZM4.275 7.25C3.96667 7.2 3.65833 7.16667 3.33333 7.16667C2.50833 7.16667 1.725 7.34167 1.01667 7.65C0.4 7.91667 0 8.51667 0 9.19167V10.5H3.75V9.15833C3.75 8.46667 3.94167 7.81667 4.275 7.25ZM16.6667 6.33333C17.5833 6.33333 18.3333 5.58333 18.3333 4.66667C18.3333 3.75 17.5833 3 16.6667 3C15.75 3 15 3.75 15 4.66667C15 5.58333 15.75 6.33333 16.6667 6.33333ZM20 9.19167C20 8.51667 19.6 7.91667 18.9833 7.65C18.275 7.34167 17.4917 7.16667 16.6667 7.16667C16.3417 7.16667 16.0333 7.2 15.725 7.25C16.0583 7.81667 16.25 8.46667 16.25 9.15833V10.5H20V9.19167ZM10 0.5C11.3833 0.5 12.5 1.61667 12.5 3C12.5 4.38333 11.3833 5.5 10 5.5C8.61667 5.5 7.5 4.38333 7.5 3C7.5 1.61667 8.61667 0.5 10 0.5Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Created Domains
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row justify-content-start">
                            <div class="d-flex">
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        All
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{ formatNumber(domains.length) }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="m-0">
                  <p
                    class="m-0 p-0 font-size-11"
                    style="margin-bottom: 2px !important"
                  >
                    This week
                  </p>
                  <div
                    class="ml-1 p-0 font-weight-bold index-overflow index-block"
                  >
                    <p class="m-0 p-0" v-if="!indexLoader">
                      {{ formatNumber(subs.subs.thisMonth) }}
                    </p>
                    <Spinner v-else class="spinner-loading--sm" />
                  </div>
                </div> -->
                            </div>
                        </div>
                        <router-link
                            tag="div"
                            :to="{ name: 'Domain List' }"
                            class="position-absolute b-7 r-0"
                            v-if="isDomainListBtnAvailable"
                        >
                            <v-btn text color="primary" x-small>
                                More Info
                            </v-btn>
                        </router-link>
                    </div>
                </div>
                <!-- PERFORMANCE -->
                <ClientPerformance v-if="isPerformanceVisible" />
                <!-- CHART -->
                <div class="row border">
                    <span
                        class="d-flex align-items-center border-bottom p-2"
                        style="font-size: 11px"
                        >SUMARRY ANALITICS</span
                    >
                    <div
                        class="d-flex justify-content-between"
                        style="height: 114px !important"
                    >
                        <div
                            class="d-flex flex-column position-relative"
                            style="margin-top: 15px; height: 34px"
                        >
                            <!-- Calendar -->
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value="datePicker"
                                :max="maxDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                style="max-height: 400px !important"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="datePickerRangeText"
                                        prepend-inner-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        full-width
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="chartLoader || fileLoading"
                                        :loading="chartLoader || fileLoading"
                                    ></v-text-field>
                                </template>
                                <v-container>
                                    <v-row
                                        class="v-menu--container__width"
                                        justify="space-around"
                                        align-content="center"
                                    >
                                        <v-col cols="7">
                                            <v-date-picker
                                                v-model="datePicker"
                                                range
                                                no-title
                                                scrollable
                                                :min="minDate"
                                                :max="maxDate"
                                                :disabled="
                                                    chartLoader || fileLoading
                                                "
                                                :loading="
                                                    chartLoader || fileLoading
                                                "
                                            >
                                            </v-date-picker>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-chip-group
                                                v-model="
                                                    selectedDateRangePreset
                                                "
                                                column
                                                class="v-chip-group--width"
                                            >
                                                <v-chip
                                                    v-for="tag in [
                                                        'Today',
                                                        'Yesterday',
                                                        'Last 7 days',
                                                        'This month',
                                                        'Last month',
                                                        'Last 30 days',
                                                        'Last 3 months',
                                                        // 'Last 6 months',
                                                    ]"
                                                    :key="tag"
                                                    :value="tag"
                                                    outlined
                                                >
                                                    {{ tag }}
                                                </v-chip>
                                            </v-chip-group></v-col
                                        >
                                    </v-row>
                                </v-container>
                            </v-menu>

                            <div
                                class="d-flex align-items-center"
                                style="margin: -7px 40px 0px 0px"
                            >
                                <v-autocomplete
                                    id="timezones"
                                    auto-select-first
                                    dense
                                    outlined
                                    v-model="selectedTimezone"
                                    style="width: 200px !important"
                                    :items="timezones"
                                    :disabled="chartLoader || fileLoading"
                                    :loading="chartLoader || fileLoading"
                                ></v-autocomplete>
                            </div>
                        </div>
                        <div class="d-flex mt-2">
                            <div class="btn-group mt-2 w-unset">
                                <v-btn
                                    class="font-size-10 text-transform-initial mr-1"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'hour'"
                                    :outlined="btnClickedTitle !== 'hour'"
                                    :color="
                                        btnClickedTitle === 'hour'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader || fileLoading"
                                    @click="btnClickedTitle = 'hour'"
                                >
                                    Hour
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial mr-1"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'day'"
                                    :outlined="btnClickedTitle !== 'day'"
                                    :color="
                                        btnClickedTitle === 'day'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader"
                                    @click="btnClickedTitle = 'day'"
                                >
                                    Day
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'week'"
                                    :outlined="btnClickedTitle !== 'week'"
                                    :color="
                                        btnClickedTitle === 'week'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader"
                                    @click="btnClickedTitle = 'week'"
                                >
                                    Week
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'month'"
                                    :outlined="btnClickedTitle !== 'month'"
                                    :color="
                                        btnClickedTitle === 'month'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader"
                                    @click="btnClickedTitle = 'month'"
                                >
                                    Month
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="py-4 position-relative">
                        <div
                            v-if="chartLoader || fileLoading"
                            class="spinner-border text-primary position-absolute"
                            role="status"
                            style="top: 45%; z-index: 99999"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <v-autocomplete
                            v-if="isModerRole"
                            v-model="selectedClient"
                            label="Select a Client"
                            outlined
                            single-line
                            hide-details
                            dense
                            :items="getClients"
                            item-value="client_uid"
                            item-text="name"
                            style="width: 200px"
                            class="py-4 m-0"
                        ></v-autocomplete>
                        <ApexChart
                            ref="apexChart"
                            initialDataVariant="All Drips"
                            @update-data-variant="handleDataVariantUpdated"
                            :dataVariants="dataVariants"
                            :fileLoading="fileLoading || chartLoader"
                            :dateTrunc="btnClickedTitle"
                            :datasets="{
                                deliveries: deliveriesSeries,
                                clicks: clicksSeries,
                                totals: totalsSeries,
                                sends: sendsSeries,
                                subs: subsSeries,
                            }"
                        />
                    </div>
                </div>
            </div>
            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <Files v-if="shwFilePopUp" @didClose="shwFilePopUp = false" />
            </transition>
            <!-- Warning -->
            <transition
                class="animate__faster"
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated animate__fadeOut animate__faster"
            >
                <Warnings
                    v-if="showWarningPopUp"
                    @didClose="showWarningPopUp = false"
                    :warningText="warningText"
                />
            </transition>
        </section>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import Error from "../popUps/Error.vue";
import Statistics from "../../apis/Statistics.js";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import Files from "../popUps/Files.vue";
import ClientPerformance from "./ClientPerformance.vue";

import { mapGetters, mapActions, mapState } from "vuex";
// import * as XLSX from "xlsx-js-style";
// import { saveAs } from "file-saver";

import ApexChart from "../../charts/ApexChart.vue";
import Spinner from "../popUps/Spinner.vue";
import Warnings from "../popUps/Warnings.vue";

import statistics from "../../mixins/statistics";
import common from "../../mixins/common";

const momentTimezone = require("moment-timezone");

export default {
    name: "MainCont",
    components: {
        //ChartLine,
        DatePicker,
        SuccessSnackbar,
        ClientPerformance,
        // GroupChart,
        ApexChart,
        Warnings,
        Spinner,
        Files,
        Error,
    },
    mixins: [statistics, common],
    data() {
        return {
            dataVariants: [
                "Deliveries",
                "Clicks",
                "Sends",
                "Subs",
                "All Drips",
                "All",
            ],

            warningText: "",
            showWarningPopUp: false,

            indexLoader: false,
            chartLoader: false,

            selectedClient: "",
            selectedDateRangePreset: "",

            selectedTimezone: momentTimezone.tz.guess(),
            timezones: momentTimezone.tz.names(),

            // fileLoading: false,

            objFileForExport: [],
            selectedChartDataVariant: "",
            selectedDataVariant: "",

            shwThingsToDo: true,
            shwChangeDmnName: false,
            shwConnectPopUp: false,

            refreshModeStatus: false,
            snackbar: false,
            // exportFormat: "select",
            respSubcr: [],
            // groupBySelectValue: "select",
            dmnStatus: null,
            btnClickedTitle: "day",

            selectedGroupBy: null,
            selectedClient: null,
            selectedDomain: null,
            selectedDripType: null,
            drips: null,
            isChartDialogOpen: false,
            filters: null,
            groupBy: null,
            isLoadingTotalMessages: false,
            isLoadingTotalSubs: false,

            dialog: false,
            menu: false,
            minDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
            maxDate: moment().format("YYYY-MM-DD"),

            welcome: {
                deliveries: {
                    totals: 0,
                    thisWeek: 0,
                },
                clicks: {
                    totals: 0,
                    thisWeek: 0,
                },
                sends: {
                    totals: 0,
                    thisWeek: 0,
                },
            },

            recurring: {
                deliveries: {
                    totals: 0,
                    thisWeek: 0,
                },
                clicks: {
                    totals: 0,
                    thisWeek: 0,
                },
                sends: {
                    totals: 0,
                    thisWeek: 0,
                },
            },

            subs: {
                subs: {
                    totals: 0,
                    thisWeek: 0,
                    thisMonth: 0,
                },
                unsubs: {},
            },
        };
    },
    computed: {
        ...mapState({
            domains: (state) => state.domain.domains,
        }),
        ...mapGetters([
            "selectedDomainWebsite",
            "roles",
            "permissions",
            "getClients",
            "clientUid",
        ]),
        isViewerRole() {
            return this.roles.includes("viewer");
        },
        isModerRole() {
            return this.roles.includes("moder");
        },
        isDomainListBtnAvailable() {
            return (
                this.roles.includes("admin") ||
                this.permissions.includes("menu.domain_list") ||
                this.permissions.includes("domain_list")
            );
        },
        isPerformanceVisible() {
            return this.permissions.includes("menu.analytics.performance")
        },
        // filteredDomainsForThisWeek() {
        //   return this.domains.filter((p) => {
        //     console.log(
        //       moment().subtract(1, "weeks").format("YYYY-MM-DD") <
        //       moment(p.created_at).format("YYYY-MM-DD"),
        //       new Date(moment(p.created_at)),
        //       new Date(moment().subtract(1, "weeks"))
        //     );

        //     return (
        //       moment().subtract(1, "weeks").format("YYYY-MM-DD") <
        //       moment(p.created_at).format("YYYY-MM-DD")
        //     );
        //   });
        // },
        visibility() {
            return;
        },
    },
    async mounted() {
        if (this.isModerRole) {
            await this.getAllClients();
            //this.selectedClient = this.getClients[0].client_uid;
        } else {
            this.selectedChartDataVariant = this.$refs.apexChart;

            await this.getInitialStats();
            await this.getTotalStatisticByDrips();
            // await this.getStatsPushErrors(
            //     moment(this.datePicker[0]).format("YYYY-MM-DD"),
            //     moment(this.datePicker[1]).format("YYYY-MM-DD"),
            //     3600,
            //     this.btnClickedTitle
            // );

            queueMicrotask(() => {
                setTimeout(() => {
                    this.chartLoader = false;
                    this.indexLoader = false;
                }, 1500);
            });
            //this.checkFileStatus();
        }
    },
    methods: {
        ...mapActions([
            "logout",
            "getAllClients",
            "show",
            "setClientUid",
            "obtainClientDomains",
            "getDripGroups",
            "getClientRecurringDrips",
        ]),
        async refreshChart() {
            this.refreshModeStatus = true;

            this.resetSeries();

            //for (let type of ["recurring", "welcome", ""]) {
            // For The Line Chart
            await this.getStatisticByDrips(
                moment().subtract(1, "weeks").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD"),
                3600,
                "day"
                //type
            );
            //}

            // Get Subs For The Line Chart & ThisWeek
            await this.getStatisticBySubs(
                moment().subtract(1, "weeks").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD"),
                3600,
                "day"
            );

            this.$nextTick(() => {
                this.refreshModeStatus = false;
            });
        },
        setChartRange(event) {
            if (event.target.id !== "exportAsFormat") {
                this.btnClickedTitle = event.target.innerText;
            }
        },
        // Get Subs For Month
        getStatisticBySubsForMonth(cache) {
            let dateStart = moment().subtract(1, "months").format("YYYY-MM-DD");
            let dateEnd = moment().format("YYYY-MM-DD");
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          cache: cache,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          cache: cache,
                      };

            Statistics.getStatsBySubscribables(
                `date_start=${dateStart}&date_finish=${dateEnd}&date_trunc=month&default_group_by=false&timezone=${this.selectedTimezone}`,
                headers
            ).then((response) => {
                this.subs["subs"]["thisMonth"] = this.getSum(
                    response.data.data,
                    "subscribed"
                );
            });
        },
        // Get subs
        getStatisticBySubs(dateStart = null, dateEnd = null, cache, date) {
            let dateTruncParams = date
                ? `date_trunc=${date}&default_group_by=false`
                : "";
            let dateParams = dateStart
                ? `&date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          cache: cache,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          cache: cache,
                      };

            return new Promise((resolve, reject) => {
                Statistics.getStatsBySubscribables(
                    dateTruncParams +
                        dateParams +
                        `&timezone=${this.selectedTimezone}`,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        // Data For The Line Chart
                        if (dateParams && dateTruncParams) {
                            this.respSubcr = [];
                            this.respSubcr = response.data.data;

                            this.subsDataForExportFile = response.data.data;

                            this.subsSeries.push(
                                this.modifyDataForCreatingCharts(
                                    response.data.data ?? 0,
                                    "full_unsubscribed",
                                    "Full Unsubscribed",
                                    this.btnClickedTitle === "hour"
                                )
                            );

                            this.subsSeries.push(
                                this.modifyDataForCreatingCharts(
                                    response.data.data ?? 0,
                                    "deactivated",
                                    "Deactivated",
                                    this.btnClickedTitle === "hour"
                                )
                            );

                            this.subsSeries.push(
                                this.modifyDataForCreatingCharts(
                                    response.data.data ?? 0,
                                    "unsubscribed",
                                    "Unsubscribed",
                                    this.btnClickedTitle === "hour"
                                )
                            );

                            this.subsSeries.push(
                                this.modifyDataForCreatingCharts(
                                    response.data.data ?? 0,
                                    "subscribed",
                                    "Subscribed",
                                    this.btnClickedTitle === "hour"
                                )
                            );
                        }

                        // Data For Totals
                        if (dateStart === null) {
                            this.subs.subs.totals = this.getSum(
                                response.data.data,
                                "subscribed"
                            );
                        }

                        // Data For ThisWeek
                        if (
                            dateStart ===
                                moment()
                                    .subtract(1, "weeks")
                                    .format("YYYY-MM-DD") &&
                            dateEnd === moment().format("YYYY-MM-DD") &&
                            date
                        ) {
                            this.subs["subs"]["thisWeek"] = this.getSum(
                                response.data.data,
                                "subscribed"
                            );
                        }
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                //localStorage.removeItem("login");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    });
            });
        },
        getTotalStatisticByDrips() {
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: 3600,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: 3600,
                      };

            this.isLoadingTotalMessages = true;

            return new Promise((resolve, reject) => {
                Statistics.getStatsEventsByDrips(
                    `&timezone=${this.selectedTimezone}&default_group_by=false&group_by=type`,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        for (let type of ["recurring", "welcome"]) {
                            this[type]["deliveries"]["totals"] =
                                response.data.data?.[type]?.[0]?.delivered ?? 0;
                            this[type]["clicks"]["totals"] =
                                response.data.data?.[type]?.[0]?.clicked ?? 0;
                            this[type]["sends"]["totals"] =
                                response.data.data?.[type]?.[0]?.sent ?? 0;
                        }
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                //localStorage.removeItem("login");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.isLoadingTotalMessages = false;
                        }, 1000);
                    });
            });
        },
        getStatsPushErrors(dateStart = null, dateEnd = null, cache, date) {
            let dateTruncParams = date ? `date_trunc=${date}&` : "";
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                      };

            return new Promise((resolve, reject) => {
                Statistics.getStatsPushErrors(
                    dateTruncParams +
                        dateParams +
                        `&timezone=${this.selectedTimezone}`,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        if (
                            Array.isArray(response.data.data) &&
                            !response.data.data.length
                        ) {
                            throw new Error("Invalid response");
                        }

                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_401",
                                "Error 401",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_403",
                                "Error 403",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_404",
                                "Error 404",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_413",
                                "Error 413",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_429",
                                "Error 429",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_x",
                                "Error X",
                                this.btnClickedTitle === "hour"
                            )
                        );
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    });
            });
        },
        getStatisticByDrips(dateStart = null, dateEnd = null, cache, date) {
            let dateTruncParams = date ? `date_trunc=${date}&` : "";
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                      };

            return new Promise((resolve, reject) => {
                Statistics.getStatsEventsByDrips(
                    dateTruncParams +
                        dateParams +
                        // dripTypeParams +
                        `&timezone=${this.selectedTimezone}&default_group_by=false&group_by=type`,
                    //)
                    //dripIdParams,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        // Data For The Line Chart
                        if (dateParams && dateTruncParams) {
                            for (let [i, type] of [
                                "recurring",
                                "welcome",
                            ].entries()) {
                                // Data For This Week
                                if (
                                    dateStart ===
                                        moment()
                                            .subtract(1, "weeks")
                                            .format("YYYY-MM-DD") &&
                                    dateEnd === moment().format("YYYY-MM-DD") &&
                                    type
                                ) {
                                    this[type]["deliveries"]["thisWeek"] =
                                        response.data.data.hasOwnProperty(type)
                                            ? this.getSum(
                                                  response.data.data[type],
                                                  "delivered"
                                              )
                                            : 0;
                                    this[type]["clicks"]["thisWeek"] =
                                        response.data.data.hasOwnProperty(type)
                                            ? this.getSum(
                                                  response.data.data[type],
                                                  "clicked"
                                              )
                                            : 0;
                                    this[type]["sends"]["thisWeek"] =
                                        response.data.data.hasOwnProperty(type)
                                            ? this.getSum(
                                                  response.data.data[type],
                                                  "sent"
                                              )
                                            : 0;
                                }

                                if (
                                    Array.isArray(response.data.data) &&
                                    !response.data.data.length
                                ) {
                                    continue;
                                }

                                this.sendsSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data?.[type] ?? 0,
                                        "sent",
                                        "Sent " + type,
                                        this.btnClickedTitle === "hour"
                                    );

                                this.clicksSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data?.[type] ?? 0,
                                        "clicked",
                                        "Clicked " + type,
                                        this.btnClickedTitle === "hour"
                                    );

                                this.deliveriesSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data?.[type] ?? 0,
                                        "delivered",
                                        "Delivered " + type,
                                        this.btnClickedTitle === "hour"
                                    );
                            }
                        }
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    });
            });
        },
        resetSeries() {
            this.sendsSeries = [];
            this.clicksSeries = [];
            this.deliveriesSeries = [];
            this.totalsSeries = [];
            this.subsSeries = [];
            this.unsubsSeries = [];
        },
        resetValues() {
            for (let obj of ["recurring", "welcome", "subs"])
                for (let key of Object.keys(obj)) {
                    if (key !== "unsubs") {
                        this[obj][key] = 0;
                    }
                }
        },
        getStatsFile() {
            this.chartLoader = true;

            queueMicrotask(() => {
                this.chartLoader = false;
            });
        },
        async getStatsForChart() {
            this.chartLoader = true;

            //for (let type of ["recurring", "welcome", ""]) {
            //For The Line Chart
            await this.getStatisticByDrips(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                3600,
                this.btnClickedTitle
            );
            //For Totals Data
            //await this.getStatisticByDrips(null, null, 3600, "", type);
            //}

            // Get Subs For The Line Chart & ThisWeek
            await this.getStatisticBySubs(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                3600,
                this.btnClickedTitle
            );

            if (this.selectedDataVariant === "Subs") {
                await this.getStatsPushErrors(
                    moment(this.datePicker[0]).format("YYYY-MM-DD"),
                    moment(this.datePicker[1]).format("YYYY-MM-DD"),
                    3600,
                    this.btnClickedTitle
                );
            }

            queueMicrotask(() => {
                this.chartLoader = false;
            });
        },
        async getInitialStats() {
            this.indexLoader = true;
            this.chartLoader = true;
            this.isLoadingTotalSubs = true;

            await this.getStatsForChart();

            // Get Totals Subs
            await this.getStatisticBySubs(null, null, 3600, "").finally(() => {
                setTimeout(() => {
                    this.isLoadingTotalSubs = false;
                }, 1000);
            });

            // Get Subs For ThisMonth
            await this.getStatisticBySubsForMonth(3600);

            await this.show({
                id: "",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    client: this.selectedClient,
                },
            });

            queueMicrotask(() => {
                this.indexLoader = false;
                this.chartLoader = false;
            });
        },
        checkIsClientSelected() {
            if (!this.selectedClient && this.isModerRole) {
                this.warningText = "Select a client!";
                this.showWarningPopUp = true;

                return false;
            } else {
                return true;
            }
        },
        setDateRangePreset(preset) {
            const today = moment();
            let start = null;
            let end = null;

            switch (preset) {
                case "Today":
                    start = today.clone().startOf("day");
                    end = today;
                    break;

                case "Yesterday":
                    start = today.clone().subtract(1, "day").startOf("day");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "Last 7 days":
                    start = today.clone().subtract(7, "days").startOf("day");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "This month":
                    start = today.clone().startOf("month");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "Last month":
                    start = today.clone().startOf("month");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "Last 30 days":
                    start = today.clone().subtract(30, "days").startOf("day");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "Last 3 months":
                    start = today
                        .clone()
                        .subtract(3, "months")
                        .startOf("month");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                case "Last 6 months":
                    start = today
                        .clone()
                        .subtract(6, "months")
                        .startOf("month");
                    end = today.clone().subtract(1, "day").startOf("day");
                    break;

                default:
                    console.error("Unknown preset:", preset);
                    return;
            }

            this.datePicker = [
                start.format("YYYY-MM-DD"),
                end.format("YYYY-MM-DD"),
            ];
        },
        getDomainsByClientUID() {
            this.obtainClientDomains({ client_uid: this.selectedClient });
        },
        getDripsByClientUID() {
            if (this.selectedDripType === "Recurring") {
                this.getClientRecurringDrips({
                    params: "",
                    headers: { client_uid: this.selectedClient },
                });
            } else if (this.selectedDripType === "Welcome") {
                this.getDripGroups({
                    params: "",
                    headers: { client_uid: this.selectedClient },
                });
            }
        },
        prepareRequestParamsToObtainChartData() {
            // Structure
            let postParams = {
                date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
                date_finish: moment(this.datePicker[1]).format("YYYY-MM-DD"),
                date_trunc: this.btnClickedTitle,
                domain_ids: this.selectedDomains.toString(),
                group_by: this.selectedGroupBy.toString(),
                timezone: this.selectedTimezone,
            };
            let headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
                cache: 3600,
                toFile: true,
            };
        },
        sendRequestToObtainChartData() {
            // if (this.selectedDataVariant === "subs") {
            //     Statistics.getStatsBySubscribablesPost(postParams, headers);
            // } else if (this.selectedDataVariant === "drips") {
            //     Statistics.getStatsEventsByDripsPost(postParams, headers);
            // }
        },
    },
    watch: {
        async selectedClient(clientUid) {
            this.indexLoader = true;
            this.chartLoader = true;

            await this.setClientUid(clientUid);

            await this.resetValues();
            await this.resetSeries();

            this.selectedChartDataVariant = this.$refs.apexChart;

            await this.getTotalStatisticByDrips();

            await this.getInitialStats();

            //await this.checkFileStatus();
        },
        selectedDateRangePreset(preset) {
            if (preset) {
                this.setDateRangePreset(preset);
            }
        },
        selectedDataVariant(type) {
            if (type === "Subs") {
                this.chartLoader = true;

                this.getStatsPushErrors(
                    moment(this.datePicker[0]).format("YYYY-MM-DD"),
                    moment(this.datePicker[1]).format("YYYY-MM-DD"),
                    3600,
                    this.btnClickedTitle
                ).finally(() => {
                    this.chartLoader = false;
                });
            }
        },
        btnClickedTitle(dateRange, prevDateRange) {
            if (!this.checkIsClientSelected()) {
                return false;
            }

            if (prevDateRange && prevDateRange !== dateRange) {
                this.resetValues();
                this.resetSeries();

                this.getStatsForChart();
            }
        },
        selectedTimezone() {
            if (!this.checkIsClientSelected()) {
                return false;
            }

            this.resetSeries();

            this.exportFormat = "select";

            this.getStatsForChart();
        },
        datePicker(value) {
            if (value.length === 1) {
                return false;
            }

            if (!this.checkIsClientSelected()) {
                return false;
            }

            this.resetSeries();

            this.exportFormat = "select";

            this.getStatsForChart();
        },
    },
};
</script>

<style scoped>
.v-menu--container__width {
    width: 540px;
}
.index-title {
    display: flex !important;
    font-size: 11px !important;
}
.index-title--svg {
    margin-right: 5px !important;
}
.index-block {
    height: 20px;
    display: flex;
    justify-content: center;
}
.index-overflow {
    overflow-x: auto;
    width: 75px;
}
::-webkit-scrollbar {
    display: none;
}
.font-size-11 {
    font-size: 11px !important;
}
select#exportAsFormat,
select#groupBySelectValue {
    background: #fff !important;
    color: #686868;
    font-size: 11px;
    border: 1px solid #68686852;
}
.box.bg-2 {
    background-color: unset !important;
}
.sub-card {
    max-width: 300px;
}
.swal2-cancel {
    color: rgb(77, 77, 77) !important;
}
.container .row:nth-child(2) div + div {
    padding-right: 3px;
}
.container .row.d-flex div.col-md-2,
.container .row.d-flex div.col-md-3 {
    border: 1px solid #dfe1e5;
    position: relative;
    /* height: 170px; */
}
.container .row:nth-child(2) div span svg {
    margin-right: 5px;
}
.container .row:nth-child(2) div span:nth-child(1),
.container .row:nth-child(2) div span:nth-child(2),
.container .row:nth-child(2) div span:nth-child(3),
.more-info-block {
    display: flex;
}
.container .row:nth-child(2) div span:nth-child(1) {
    font-size: 11px;
}
.container .row:nth-child(2) div span:nth-child(2) {
    font-weight: 700;
    font-size: 24px;
}
.small-text {
    font-size: 14px;
    color: #272727;
}
.more-info-block {
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    /* left: 13px; */
    width: 100%;
    left: 0;
    padding: 12px 12px 12px;
    font-size: 11px;
    background: #ebebec;
}
.col-md-2 {
    flex: 0 0 15.666667% !important;
}

.btn-group {
    margin: 12px 0 0 0;
    width: 206px;
    height: 31px;
}

.chart-btn {
    width: 63px;
    height: 31px;
    padding: 9px 20px;
    border: 1px solid #bdbdbd;
    border-radius: 4px;
    font-weight: 500;
    font-size: 9px;
    color: #7f7f7f !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 12px 0 0;
}

.chart-btn-active {
    border: 1px solid #3579f5;
    background: #3579f5 !important;
    color: #fff !important;
    box-shadow: 0px 2px 2px 0px #a3a3a3;
}

.chart-btn.chart-btn-active:hover {
    background: #2b66d3 !important;
}

.chart-btn:not(.chart-btn.chart-btn-active):hover {
    border: 1px solid #949494;
    color: #686767 !important;
}

.v-input__slot {
    width: 71px !important;
    font-size: 14px !important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
    border: unset !important;
}

.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    font-size: 15px !important;
}

@media (max-width: 768px) {
    .navbar-nav.ml-auto {
        overflow-x: scroll;
    }
    .lst-notif-block {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .mt-mb-style {
        margin-top: 3rem !important;
    }
    .mb-font-size {
        font-size: 12px !important;
    }
}
</style>
